import { createSlice } from "@reduxjs/toolkit";
import { getinstagramCreativeList } from "./ThunkActions";
import {  REDUCER_NAME, IinstagramCreativeState } from "./Types";

// Define initial state based on the provided structure
const initialState: IinstagramCreativeState = {
  isLoading: false,
  instagramCreativeList: [],
  errorMessage: null,
};

export const instagramCreativeSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetinstagramCreativeState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getinstagramCreativeList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getinstagramCreativeList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.instagramCreativeList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getinstagramCreativeList.rejected, (state) => {
        state.errorMessage = "Failed to fetch Creative list";
        state.isLoading = false;
      });
  },
});

export const { resetinstagramCreativeState } = instagramCreativeSlice.actions;
export default instagramCreativeSlice.reducer;
